import _ from 'lodash';

export default {
  filters: {
    customerName(loadDetails) {
      return _.get(loadDetails, 'customerCompany.name');
    },
    producerName(loadDetails) {
      return _.get(loadDetails, 'listingCompany.name');
    },
    originName(loadDetails) {
      return _.get(loadDetails, 'pickupLocation.googlePlace.placeName') ||
             _.get(loadDetails, 'pickupLocation.googlePlace.formattedAddress');
    },
    originRegion(loadDetails) {
      return _.get(loadDetails, 'pickupLocation.googlePlace.region');
    },
    originAddress(loadDetails) {
      return _.get(loadDetails, 'pickupLocation.googlePlace.formattedAddress');
    },
    destinationName(loadDetails) {
      return _.get(loadDetails, 'dropoffLocation.googlePlace.placeName') ||
             _.get(loadDetails, 'dropoffLocation.googlePlace.formattedAddress');
    },
    destinationRegion(loadDetails) {
      return _.get(loadDetails, 'dropoffLocation.googlePlace.region');
    },
    destinationAddress(loadDetails) {
      return _.get(loadDetails, 'dropoffLocation.googlePlace.formattedAddress');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/companyNames.js